<template>
  <div class="new-module-content-bg-grey">
    <div class="flow-page main-content">
      <div class="page-title">
        <p class="title-text">参赛流程</p>
        <span class="text-en">APPLICATION PROCESS</span>
      </div>
      <stepActive :stepNum="3"/>
      <div class="input-module">
        <moduleTop top-text="审核中"/>
        <div class="input-module-box">
          <img class="up-ed-img" :src="require('@/assets/uped_img.png')" alt="已上传">
          <div class="handle-box">
            <p class="handle-next" @click="toIndex">
              返回首页
            </p>
            <p class="handle-next" @click="toControl">
              作品管理
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import stepActive from "@/views/flow/components/stepActive";
import moduleTop from "@/components/moduleTop";
export default {
  name: "step2",
  components:{
    stepActive,
    moduleTop
  },
  data() {
    return {}
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    toIndex(){
      this.$router.push({name:'About'})
    },
    toControl(){
      this.$router.push({name:'userWorks'})
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.flow-page {
  padding-bottom: 168px;
  .input-module {
    margin-top: 58px;
    .input-tip {
      font-size: 23px;
      color: #c3ad94;
      margin-bottom: 14px;
    }
    //.module-top {
    //  width: 100%;
    //  height: 109px;
    //  display: flex;
    //  justify-content: space-between;
    //  align-items: center;
    //  background-color: $bgColor-2;
    //  padding: 0 45px;
    //  font-size: 32px;
    //  color: #fff;
    //  font-weight: bold;
    //  & > img {
    //    display: block;
    //    width: 92px;
    //  }
    //}
    .input-module-box {
      padding: 87px 46px 198px;
      background-color: #fff;
      .up-ed-img {
        display: block;
        width: 196px;
        margin: 0 auto;
      }
      .handle-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 0px;
        margin-left: 440px;
        margin-right: 440px;
      }
    }
    .handle-next {
      display: block;
      width: 185px;
      line-height: 48px;
      text-align: center;
      color: #fff;
      font-weight: 300;
      //border: 1px solid $blockColor--1;
      background-color: #A62325 ;
      margin: 87px auto 0;
      cursor: pointer;
    }
  }
}
</style>
